import { memberCommentService } from '../../clients/ApiClients';
import MemberCommentThread, { MemberThreadSource } from './MemberCommentThread';

interface Props {
  violationId: string;
}

/**
 * The shared thread on one of the member's own violations (#126).
 *
 * The scope is the server's decision and is always `SharedOnly` here.
 * There is nothing to filter client-side and nothing to ask for: an
 * internal comment 404s exactly as a nonexistent one does, which is what
 * keeps the id space unprobeable.
 */
export function MemberViolationCommentThread({ violationId }: Props) {
  const source: MemberThreadSource = {
    list: async () => {
      const { data } = await memberCommentService.listMyViolationComments({ violationId });
      return data.comments ?? [];
    },
    post: (content, parentId) =>
      memberCommentService.createMyViolationComment({
        memberCommentCreate: {
          content,
          violation_id: violationId,
          ...(parentId ? { parent_id: parentId } : {}),
        },
      }),
    remove: (commentId) => memberCommentService.deleteMyViolationComment({ commentId }),
  };

  return (
    <MemberCommentThread
      source={source}
      sourceKey={violationId}
      emptyText="No messages yet. You can write to your community manager about this violation here."
      sendLabel="Send to your community manager"
    />
  );
}

export default MemberViolationCommentThread;
